<template>
  <!-- <v-container :style="{ width: props.readOnly ? '' : '100%' }"> -->
  <span>Formel</span>
  <div
    :style="{ width: props.readOnly ? '300px' : '100%' }"
    :id="mathFieldID"></div>
  <v-btn
    v-if="!props.readOnly"
    @click="$emit('legend', legendItems)"
    >in Legende übernehmen</v-btn
  >
  <!-- </v-container> -->
</template>

<script lang="ts" setup>
import { uuid4 } from "@sentry/core";
import { MathfieldElement } from "mathlive";
import { onMounted, Ref, ref } from "vue";

const modelValue = defineModel<string>();

const legendItems: Ref<string[]> = ref([]);

const props = defineProps({
  readOnly: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["legend"]);

const mathFieldID = uuid4();

onMounted(() => {
  const mathFieldElement = document.getElementById(mathFieldID) as HTMLElement;
  const mfe = new MathfieldElement();
  mfe.readOnly = props.readOnly;
  mfe.oninput = (e) => {
    modelValue.value = mfe.value;
    analyzeLegend(mfe.value);
  };

  mfe.addEventListener("menu-select", async (event) => {
    if (event.detail.id !== "paste") return;
    event.preventDefault();
    const text = await navigator.clipboard.readText();
    mfe.value = transform(text);
    modelValue.value = mfe.value;
    analyzeLegend(mfe.value);
    // mfe.value = mfe.value.replaceAll("^{1}","^")
  });

  mfe.style.width = "100%";
  mfe.style.fontSize = "1.44em"
  mfe.value = modelValue.value;
  analyzeLegend(mfe.value);
  mathFieldElement.appendChild(mfe);
});

function analyzeLegend(input: string) {
  legendItems.value = [];
  console.log("input", input);

  let sumValues = input.matchAll(
    /\\sum_{(?<sum_under>.+?)}\^{(?<sum_over>.+?)}/g
  );
  input = input.replaceAll(/\\sum_/g, "");
  console.log("input", input);
  const otherItems = input.matchAll(/(?<val>\w+_\{.+?\}\}?)*/g);
  const otherItems2 = input.matchAll(/(?<val>\w+_\(.+?\)\}?)*/g);

  if (sumValues) {
    for (const i of sumValues) {
      if (!i.groups) continue;
      console.log("sumValues", i.groups.sum_under);
      let result = i.groups.sum_under
        .replaceAll("_", "")
        .replaceAll("\^{∗}", "<sup>*</sup>")
        .replaceAll("\^{∗∗", "<sup>**</sup>")
        .replaceAll("\^{\\ast}", "<sup>*</sup>")
        .replaceAll("\^{\\ast\\ast", "<sup>**</sup>")
        .replaceAll("{", "<sub>")
        .replaceAll("}", "</sub>");
      console.log("result", result);
      let result2 = i.groups.sum_over
        .replaceAll("_", "")
        .replaceAll("\^{∗}", "<sup>*</sup>")
        .replaceAll("\^{∗∗", "<sup>**</sup>")
        .replaceAll("\^{\\ast\\ast", "<sup>**</sup>")
        .replaceAll("\^{\\ast}", "<sup>*</sup>")
        .replaceAll("{", "<sub>")
        .replaceAll("}", "</sub>");
      legendItems.value.push(result);
      legendItems.value.push(result2);
    }
  }

  console.log("otherItems", otherItems, otherItems?.groups);
  if (otherItems) {
    for (const i of otherItems) {
      // console.log("i", i, i.groups);
      if (!i.groups?.val) continue;

      let result = i.groups.val
        .replaceAll("_", "")
        .replaceAll("{", "<sub>")
        .replaceAll("}", "</sub>");
      legendItems.value.push(result);
    }
  }
  if (otherItems2) {
    for (const i of otherItems2) {
      // console.log("i", i, i.groups);
      if (!i.groups?.val) continue;

      let result = i.groups.val
        .replaceAll("_", "")
        .replaceAll("{", "<sub>")
        .replaceAll("}", "</sub>");
      legendItems.value.push(result);
    }
  }

  //transform(
  //  "〖𝑀𝐴𝐾〗_𝑔𝑑𝑖=∑(𝑚=1)^(𝑚^(**))▒〖𝑀𝐴𝐾〗_𝑔𝑑𝑖𝑚 +(((〖𝐴𝑀〗_𝑔𝑑𝑖/(1−〖𝐹𝐴〗_𝑔𝑑𝑖 ))−〖𝐴𝑀〗_𝑔𝑑𝑖)/〖𝐴𝑀〗_𝑔𝑑𝑖 )∙(∑(𝑒=1)^(𝑒^(**))▒〖〖𝑉𝐾𝐹〗_(𝑔𝑑+1𝑒)∙〖𝑀𝐾〗_(𝑔𝑑+1𝑒) 〗+∑(𝑖=𝑖^*)^(𝑖^(**))▒〖𝑀𝐾〗_𝑔𝑑𝑖 )"
  //);
  // Output: $$ \sum_{m=1}^{m}MAK_{gdim}+\left(\frac{\left(\frac{AM_{gdi}}{1-FA_{gdi}}\right)-AM_{gdi}}{AM_{gdi}}\right)\cdot\sum_{e=1}^{e}VKF_{gd+1e}\cdot MK_{gd+1e}+\sum_{i=i}^{i}MK_{gdi} $$
  // A = 119859
  // M = 119872
  // i = 119894
  // z = 119911
}

function transform(input: string) {
  // const result = input.replaceAll(/[\u{1D433}-\u{1D467}]/u, "");
  // return result;
  //
  console.log("transform input", input);
  for (const [key, value] of Object.entries(replaceTable)) {
    input = input.replaceAll(getRegex(key), value);
  }
  console.log("normal a-Z", input);

  // Input regex from PPT
  // Replace sum
  input = input.replaceAll(/∑_?\((.*?)\)\^\((.*?)\)▒/g, "\\sum_{$1}^{$2}");
  console.log("replace sum", input);

  // Replace other ()
  // input = input.replaceAll(/(〖\w+?〗)_\((.*?)\)/g, "$1_$2");
  // console.log("replace other", input);

  // replace name elements
  input = input.replaceAll(/〖([\w\s.]+)〗_([\w]+)/g, "$1_{$2}"); // replace with only words
  console.log("replace name Step 1", input);
  input = input.replaceAll(/〖([\w\s.]+)〗_\(([\w+\s.]+)\)/g, "$1_{$2}"); // replace with + in under
  console.log("replace name Step 2", input);
  input = input.replaceAll(/〖(\w+)〗_\(([\w{}\s.]+)\)/g, "$1_{$2}"); // replace double under
  console.log("replace name Step 3", input);
  input = input.replaceAll(/(\w)_([\w]+)/g, "$1_{$2}"); // replace single char normal
  console.log("replace name Step 4", input);
  input = input.replaceAll(/(\w)_\(([\w+\s.]+)\)/g, "$1_{$2}"); // replace single char with + in under
  console.log("replace name Step 5", input);
  input = input.replaceAll(/(\w)_\(([\w{}\s.]+)\)/g, "$1_{$2}"); // replace single char with double under
  console.log("replace name", input);

  // find fractions
  let fractions = getFraction(input);
  console.log("fractions", fractions);

  // replace fractions
  for (const fraction of fractions.reverse()) {
    const fractionResult = fraction.replace(/(.*)\/(.*)/, "\\frac{$1}{$2}");
    input = input.replace(fraction, fractionResult);
  }
  console.log("replace fractions", input);

  // remove special brackets
  input = input.replaceAll(/〖/g, "").replaceAll(/〗/g, "");

  // fix *
  input = input.replaceAll(/(\w+)\^\(?(∗+)\)?/g, "$1\^{$2}")

  // replace standard brackets with mathlive syntax
  input = input.replaceAll("(", "\\left(").replaceAll(")", "\\right)");
  // replace multiplication characters
  input = input.replaceAll("∙", "\\cdot ");
  // replace exponent characters
  // input = input.replaceAll(/\^\^/g, "");
  // input = input.replaceAll(/(\w)\^/g, "$1");


  console.log("final", input);

  return input;
}

function getFraction(input: string) {
  let bracketNumber = 0;
  let slashNumber = 0;
  let bracketIndex: { [key: number]: number } = {};
  let results = [];
  for (let i = 0; i < input.length; i++) {
    if (input[i] === "(") {
      bracketNumber = bracketNumber + 1;
      bracketIndex[bracketNumber] = i;
    } else if (input[i] === ")") {
      if (slashNumber === bracketNumber) {
        results.push(input.slice(bracketIndex[slashNumber] + 1, i));
        slashNumber = 0;
      }

      bracketNumber = bracketNumber - 1;
    } else if (input[i] === "/") slashNumber = bracketNumber;
  }
  return results;
}

function getRegex(key: string) {
  console.log("getRegex", key, Number(key).toString(16));
  let hex = Number(key).toString(16);
  let temp = "\\u{" + hex + "}";
  return new RegExp(temp, "gu");
}

const replaceTable = {
  119860: "A",
  119861: "B",
  119862: "C",
  119863: "D",
  119864: "E",
  119865: "F",
  119866: "G",
  119867: "H",
  119868: "I",
  119869: "J",
  119870: "K",
  119871: "L",
  119872: "M",
  119873: "N",
  119874: "O",
  119875: "P",
  119876: "Q",
  119877: "R",
  119878: "S",
  119879: "T",
  119880: "U",
  119881: "V",
  119882: "W",
  119883: "X",
  119884: "Y",
  119885: "Z",
  119886: "a",
  119887: "b",
  119888: "c",
  119889: "d",
  119890: "e",
  119891: "f",
  119892: "g",
  119893: "h",
  119894: "i",
  119895: "j",
  119896: "k",
  119897: "l",
  119898: "m",
  119899: "n",
  119900: "o",
  119901: "p",
  119902: "q",
  119903: "r",
  119904: "s",
  119905: "t",
  119906: "u",
  119907: "v",
  119908: "w",
  119909: "x",
  119910: "y",
  119911: "z"
};
</script>

<style lang="scss">
body {
  --keyboard-zindex: 3000;
}
</style>

<!-- $$ x=\sum_0^{n}M_{gdi}+x_{as_{ds}}\cdot a^2\cdot\sum_4^3asd+\sum_{a}^2 $$ -->

<!--  -->
